<template>
    <section class="cities">
        <button class="cities__current-city link" type="button" @click="openCitiesList">
            {{cityName}}
            <svg class="icon">
                <use xlink:href="#arrow"/>
            </svg>
        </button>
        <transition name="opacity">
            <ul class="cities__list" v-if="citiesListActive">
                <li class="cities__item" v-for="cityItem of cities">
                    <a :href="cityItem.url" class="link cities__item-link _underline">
                        <span>{{ cityItem.name }}</span>
                        <svg viewBox="0 0 13 20">
                            <polyline points="0.5 19.5 3 19.5 12.5 10 3 0.5"/>
                        </svg>
                    </a>
                    <a class="cities__item-phone link" :href="'tel:' + cityItem.phone ">
                        {{ cityItem.phone }}
                    </a>
                    <div class="cities__item-inner" v-for="cityItemOffice of cityItem.shops.data">
                        <span class="cities__item-office">{{ cityItemOffice.name }}</span>
                        <span class="cities__item-time" v-if="cityItemOffice.work_time"
                              v-html="cityItemOffice.work_time"></span>
                    </div>
                </li>
            </ul>
        </transition>
    </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'cities',
    data() {
        return {
            citiesListActive: false,
        }
    },
    methods: {
        ...mapActions(['fetchCities']),
        openCitiesList() {
            this.citiesListActive = !this.citiesListActive;
        }
    },
    computed: mapGetters(['cities', 'cityName']),
    async created(){
        await this.fetchCities();
    }
}

</script>
